import { Row, Col } from "@folio/stripes/components";
import React from "react";
import { useIntl } from "react-intl";
import RenderField from "../../../components/RenderField";
import { formatDate } from "../../../utils/dateTimeUtil";
export var TimestampsAccordion = function (_a) {
    var publisher = _a.publisher;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.ares.field.label.timeOfRegistration",
                    }), value: formatDate(publisher.createTime) })),
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.ares.field.label.timeOfActivation",
                    }), value: formatDate(publisher.activationTime) }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.ares.field.label.timeOfConfirmation",
                    }), value: formatDate(publisher.dataConfirmationTime) })),
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.ares.field.label.timeOfClosure",
                    }), value: formatDate(publisher.closeTime) })))));
};
